import { transport } from 'config/transport';

export function callApiGetNuns(congDoanId, isActive) {
    return transport.get(`/congdoan/${congDoanId}/nun`, { params: { isActive } });
}
